<template>
  <page-outline 
    :title="$t('Webheader.configuration_list_' + entitiesType)"
    :show-filter="true"
    :show-refresh="true"
    :show-extract="flagCACP && messageRoutingIn.length > 0"
    :filter-expanded="displayFilter"
    :refresh-disabled="activateSpinner"
    @toggle-filter="toggleFilter"
    @refresh="onRefresh"
    @extract="extractCSV">
    
    <!-- Filtres intégrés avec AppPanel -->
    <template v-slot:filterContent>
      <app-panel
        :filters="filterConfig"
        :searchAriaLabel="$t('common.srch') + ' ' + $t('Webheader.configuration_list_' + entitiesType)"
        @filter-changed="onFilterChanged"
        @clear-filters="clearFilterFields"
        @apply-filters="onRefresh"
      />
    </template>
    
    <template v-slot:pageContent>
      <b-container fluid class="listPage">
      <!--      <div class="ml-3 mt-xl-0 text-xl-center">-->
<!--        <b-button-group class="">-->
<!--          <b-button :variant="type === 0 ? 'primary btn-selected' : ''" @click="type = 0">{{ $t('common.routing.type_0') }}</b-button>-->
<!--          <b-button :variant="type === 1 ? 'primary btn-selected' : ''" @click="type = 1">{{ $t('common.routing.type_1') }}</b-button>-->
<!--        </b-button-group>-->
<!--      </div>-->
<!--      <div class="ml-3 mt-xl-0 text-xl-center">-->
<!--        <b-button-group class="">-->
<!--          <b-button :variant="role === 0 ? 'primary btn-selected' : ''" @click="role = 0">{{ $t('common.routing.role_0') }}</b-button>-->
<!--          <b-button :variant="role === 1 ? 'primary btn-selected' : ''" @click="role = 1">{{ $t('common.routing.role_1') }}</b-button>-->
<!--        </b-button-group>-->
<!--      </div>-->
    <b-row class="justify-content-start">
      <b-col cols="4" lg="3" xl="3" class="my-2" v-if="canGetEntityGroup() && entitiesType == 'requester'">
        <app-button
          :text="$t('common.routing.consult_list_entity_group')"
          variant="primary"
          :block="true"
          custom-class="mr-3 justify-item-end responsive-button"
          @click="getEntityGroup">
        </app-button>
      </b-col>
      <b-col cols="4" lg="3" xl="3" class="my-2" v-if="canAddMessageRouting && !activateSpinner && demo">
        <app-button
          :text="getAddButtonText()"
          icon="fa-light fa-plus"
          variant="primary"
          :block="true"
          custom-class="mr-3 justify-item-end responsive-button"
          @click="addMessageRouting">
        </app-button>
      </b-col>
      <b-col cols="4" lg="3" xl="3" class="my-2" v-if="canViewConnector() && (entitiesType == 'rvm' || entitiesType == 'requester')">
        <app-button
          :text="$t('common.routing.receiver')"
          variant="primary"
          :block="true"
          custom-class="mr-3 justify-item-end responsive-button"
          @click="getConfiguration('requester')">
        </app-button>
      </b-col>
      <b-col cols="4" lg="3" xl="3" class="my-2" v-if="canViewConnector() && (entitiesType == 'rvm' || entitiesType == 'responder')">
        <app-button
          :text="$t('common.routing.sender')"
          variant="primary"
          :block="true"
          custom-class="mr-3 justify-item-end responsive-button"
          @click="getConfiguration('responder')">
        </app-button>
      </b-col>
      <b-col class="my-2" v-if="entitiesType != 'decentralised'" cols="4" lg="3" xl="3">
        <app-button
          :text="$t('common.routing.import_referentiel')"
          icon="fa-light fa-plus"
          variant="primary"
          :block="true"
          :disabled="true"
          custom-class="justify-item-end responsive-button"
          @click="addImportReferentiel">
        </app-button>
      </b-col>


      <b-col cols="3" lg="2" xl="2" class="my-2" v-if="canViewConnector() && entitiesType == 'decentralised'">
        <app-button
          :text="$t('common.routing.update_connector_stet')"
          variant="primary"
          :block="true"
          custom-class="mr-3 justify-item-end responsive-button"
          @click="getConfigurationS3('2', '1')">
        </app-button>
      </b-col>
      <b-col cols="3" lg="2" xl="2" class="my-2" v-if="canViewConnector() && entitiesType == 'decentralised'">
        <app-button
          :text="$t('common.routing.update_connector_entity')"
          variant="primary"
          :block="true"
          custom-class="mr-3 justify-item-end responsive-button"
          @click="getConfigurationS3('2', '2')">
        </app-button>
      </b-col>
      <b-col cols="3" lg="2" xl="2" class="my-2" v-if="canViewConnector() && entitiesType == 'decentralised'">
        <app-button
          :text="$t('common.routing.update_connector_cacp')"
          variant="primary"
          :block="true"
          custom-class="mr-3 justify-item-end responsive-button"
          @click="getConfigurationS3('3', '2')">
        </app-button>
      </b-col>
      <b-col cols="3" lg="2" xl="2" class="my-2" v-if="canViewConnector() && entitiesType == 'decentralised'">
        <app-button
          :text="$t('common.routing.update_connector_notification')"
          variant="primary"
          :block="true"
          custom-class="mr-3 justify-item-end responsive-button"
          @click="getConfigurationS3('3', '2', 'WEBSERVICE')">
        </app-button>
      </b-col>

<!--      <b-row class="justify-content-start no-gutters">-->
<!--        <div class="text-xl-center">-->
<!--          <b-button-group class=" d-xl-inline-flex">-->
<!--            <b-button v-if="entitiesType == 'rvm' || entitiesType == 'requester'" class="config-buttons-title" @click="getConfiguration()">{{ $t('common.routing.receiver') }}</b-button>-->
<!--            <b-button v-if="entitiesType == 'rvm' || entitiesType == 'responder'" class="config-buttons-title" @click="getConfiguration()">{{ $t('common.routing.sender') }}</b-button>-->
<!--          </b-button-group>-->
<!--        </div>-->
<!--      </b-row>-->
<!--          <b-button class="mx-3" variant="secondary"-->
<!--                    @click="addMessageRouting"-->
<!--                    >-->
<!--            <i class="fa-light fa-plus"></i>-->
<!--            <span>{{$t('common.routing.add_message_routing')}}</span>-->
<!--          </b-button>-->
    </b-row>
    <br />
    <b-tabs nav-class="d-none">
      <b-tab :title="$t('common.routing.in')">
        <b-row>
          <b-col md="12">
            <spinner v-if="activateSpinner"></spinner>
            <div v-else>
              <!-- DR : Changer de fixed à relative pour que les tables soient scrollable (pratique pour les users mobile/tablette)-->
              <b-table hover relative responsive
                v-if="messageRoutingIn.length"
                class="mt-3 table-striped"
                :items="messageRoutingIn"
                :fields="fields"
                selectable select-mode="single" @row-selected="seeDetails">
                <template #cell(RoutingType)="data">
                  <span v-if="data.item.MessageType == 0">DDV</span>
                  <span v-if="data.item.MessageType == 1">DDD</span>
                  <span v-if="data.item.MessageType == 2">DMA</span>
                  <span v-if="data.item.MessageType == 3">DMA_CACP</span>
                </template>
                <template #cell(ConfigType)="data">
                  <span>
                    {{ data.item.ConfigType === "NULL" ? data.item.ConfigType : data.item.ConfigType === data.item.ConfigType ? data.item.ConfigType : data.item.ConfigType + " / " + data.item.ConfigType}}
                    <!-- {{ data.item.Configs[0].ConfigType == data.item.Configs[1].ConfigType ? data.item.Configs[0].ConfigType : data.item.Configs[0].ConfigType +' / '+data.item.Configs[1].ConfigType }} -->
                  </span>
                </template>
                <template #cell(ConfigIn)="data" v-if="entitiesType == 'rvm' || entitiesType == 'requester'">
                  <span>
                   {{ data.item.NameConfigInput == '' ? '-' : data.item.NameConfigInput }}
                  </span>
                </template>
                <template #cell(ConfigOut)="data" v-if="entitiesType == 'rvm' || entitiesType == 'responder' || entitiesType == 'decentralised'">
                  <span >
                   {{ data.item.NameConfigOutput == '' ? '-' : data.item.NameConfigOutput }}
                  </span>
                </template>
                <template #cell(Active)="data">
                  <span >
                   {{ data.item.Active == '1' ? $t('common.routing.active_1') : $t('common.routing.active_0')}}
                  </span>
                </template>
                <template #cell(BillableBic)="data" v-if="flagCACP && (entitiesType === 'responder' || entitiesType === 'decentralised' || entitiesType === 'requester')">
                  <span>
                   {{ data.item.BillableBic == '' ? '-' : data.item.BillableBic }}
                  </span>
                </template>
              </b-table>

              <div v-else class="d-flex justify-content-center">
                <span class="noResult">
                  {{ $t('common.no_result') }}
                </span>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col>
            <cm-pagination
              :maxResultsByPage="paginationObject.maxResults"
              :firstIndex="paginationObject.firstIndex"
              :nbResultsTotal="paginationObject.nbResultsTotal"
              :refreshEvent="paginationObject.refresh">
            </cm-pagination>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
      </b-container>
    </template>
  </page-outline>
</template>

<script>

import conf from '../../config/config.dev.js'
import Spinner from '@/components/common/spinner.vue'
import Pagination from '@/components/common/pagination.vue'
import AppButton from '@/components/common/AppButton.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import AppPanel from '@/components/common/AppPanel.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import moment from 'moment-timezone'

export default {
  name: 'MessageList',
  components: {
    'cm-pagination': Pagination,
    'spinner': Spinner,
    'app-button': AppButton,
    'page-outline': PageOutline,
    'app-panel': AppPanel
  },
  props: {
    roleFromURL: {
      type: String,
      default: '0'
    },
    typeFromURL: {
      type: String,
      default: '0'
    },
    entitiesType: {
    },
    tabName: {
    },
  },
  computed: {
    filterConfig() {
      const statusOptions = [
        { value: 'ALL', labelKey: 'common.all' },
        { value: '1', labelKey: 'common.active' },
        { value: '0', labelKey: 'common.inactive' },
      ]
      const routageTypeOptions = [
        { value: 'ALL', labelKey: 'common.all' },
        { value: '0', labelKey: 'DDV' },
        { value: '1', labelKey: 'DDD' }
      ]
      const configurationTypeOptions = [
        { value: 'ALL', labelKey: 'common.all' },
        { value: 'MQSERIES', labelKey: 'MQ' },
        { value: 'WEBSERVICE', labelKey: 'Webservice' }
      ]
      const RVMOptions = [
        { value: 'ALL', labelKey: 'common.all' },
        { value: '1', labelKey: 'Sepamail' },
        { value: '2', labelKey: 'ABE Clearing' }
      ]
      const filters = []


      if (this.entitiesType == 'rvm') {
        filters.push({
          id: 'filter-receiver-id',
          type: 'text',
          prop: 'receiverId',
          labelKey: this.flagCACP ? 'common.routing.flagCACP.entity_bic' : 'common.routing.receiver_id_' + this.entitiesType,
          icon: 'fa-solid fa-building',
          value: this.filterValues.receiverId,
          colSm: '3',
          colLg: '3'
        })
        filters.push({
          id: 'filter-bic-on-us',
          type: 'switch',
          prop: 'bicOnUs',
          labelKey: 'common.routing.flagCACP.bic_on_us',
          icon: 'fa-solid fa-building-columns',
          value: this.filterValues.bicOnUs,
          colSm: '3',
          colLg: '3'
        })
        filters.push({
          id: 'filter-status',
          type: 'select',
          prop: 'status',
          labelKey: 'common.routing.flagCACP.status',
          icon: 'fa-solid fa-traffic-light',
          value: this.filterValues.status,
          defaultOptionKey: 'common.routing.select_status_placeholder',
          options: statusOptions,
          colSm: '3',
          colLg: '3'
        })
        filters.push({
          id: 'filter-routage-type',
          type: 'select',
          prop: 'routingType',
          labelKey: 'common.routing.routage_type',
          icon: 'fa-solid fa-share-nodes',
          value: this.filterValues.routingType,
          defaultOptionKey: 'common.routing.select_routage_type_placeholder',
          options: routageTypeOptions,
          colSm: '3',
          colLg: '3'
        })
        filters.push({
          id: 'filter-configuration-type',
          type: 'select',
          prop: 'configurationType',
          labelKey: 'common.routing.configuration_type',
          icon: 'fa-solid fa-sliders',
          value: this.filterValues.configurationType,
          defaultOptionKey: 'common.routing.select_configuration_type_placeholder',
          options: configurationTypeOptions,
          colSm: '3',
          colLg: '3'
        })
        filters.push({
          id: 'filter-RVM',
          type: 'select',
          prop: 'RVM',
          labelKey: 'common.routing.RVM',
          icon: 'fa-solid fa-database',
          value: this.filterValues.RVM,
          defaultOptionKey: 'common.routing.select_RVM_placeholder',
          options: RVMOptions,
          colSm: '3',
          colLg: '3'
        })
        filters.push({
          id: 'filter-date',
          type: 'datetime',
          prop: 'date',
          labelKey: 'common.routing.date_filter',
          icon: 'fa-solid fa-calendar-days',
          value: this.filterValues.date,
          colSm: '3',
          colLg: '3'
        })

      }
      else {
        filters.push({
          id: 'filter-receiver-id',
          type: 'text',
          prop: 'receiverId',
          labelKey: this.flagCACP ? 'common.routing.flagCACP.entity_bic' : 'common.routing.receiver_id_' + this.entitiesType,
          icon: 'fa-solid fa-building',
          value: this.filterValues.receiverId,
          colSm: '6',
          colLg: '6'
        })
        filters.push({
          id: 'filter-billable-bic',
          type: 'text',
          prop: 'billableBic',
          labelKey: 'common.routing.flagCACP.billable_bic',
          icon: 'fa-solid fa-credit-card',
          value: this.filterValues.billableBic,
          colSm: '3',
          colLg: '3'
        })
      }

      return filters
    },
    shouldShowFilter() {
      // Afficher le filtre pour tous les types d'entités
      return true
    },
    canAddMessageRouting () {
      return this.$engine.firstOn().rights.rightIs('messageRoutingConfig_add', true)
    },
    fields () {
      let field
      if (this.entitiesType === 'requester') {
        field =  [
          { key: 'RoutingType', label: this.$t('common.routing.routing_type'), class: 'text-center table-condensed' },
          { key: 'RoutingName', label: this.$t('common.routing.routing_name_' + this.entitiesType), class: 'text-center table-condensed' },
          { key: 'ReceiverId', label: this.$t('common.routing.receiver_id_' + this.entitiesType), class: 'text-center table-condensed' },
          { key: 'ConfigType', label: this.$t('common.routing.config_type'), class: 'text-center table-condensed' },
          { key: 'ConfigIn', label: this.$t('common.routing.connector_name_receiver'), class: 'text-center table-condensed' },
          { key: 'Active', label: this.$t('common.routing.active'), class: 'text-center table-condensed' },
        ]
        if (this.flagCACP) {
          field.splice(1, 0, { key: 'RoutingName', label: this.$t('common.routing.flagCACP.entity_label'), class: 'text-center table-condensed' })
          field.splice(2, 0, { key: 'ReceiverId', label: this.$t('common.routing.flagCACP.entity_bic'), class: 'text-center table-condensed' })
          field.splice(3, 0, { key: 'BillableBic', label: this.$t('common.routing.flagCACP.billable_bic'), class: 'text-center table-condensed' })
          field.push({ key: 'Active', label: this.$t('common.routing.flagCACP.activity'), class: 'text-center table-condensed' })
        }
      }
      else if (this.entitiesType === 'responder') {
        field =  [
          { key: 'RoutingType', label: this.$t('common.routing.routing_type'), class: 'text-center table-condensed' },
          { key: 'RoutingName', label: this.$t('common.routing.routing_name_' + this.entitiesType), class: 'text-center table-condensed' },
          { key: 'ReceiverId', label: this.$t('common.routing.receiver_id_' + this.entitiesType), class: 'text-center table-condensed' },
          { key: 'ConfigType', label: this.$t('common.routing.config_type'), class: 'text-center table-condensed' },
          { key: 'ConfigOut', label: this.$t('common.routing.connector_name_responder'), class: 'text-center table-condensed' },
          { key: 'Active', label: this.$t('common.routing.active'), class: 'text-center table-condensed' },
        ]
        if (this.flagCACP) {
          field.splice(1, 0, { key: 'RoutingName', label: this.$t('common.routing.flagCACP.entity_routing_name'), class: 'text-center table-condensed' })
          field.splice(2, 0, { key: 'ReceiverId', label: this.$t('common.routing.flagCACP.entity_bic'), class: 'text-center table-condensed' })
          field.splice(3, 0, { key: 'BillableBic', label: this.$t('common.routing.flagCACP.billable_bic'), class: 'text-center table-condensed' })
          field.push({ key: 'Active', label: this.$t('common.routing.flagCACP.activity'), class: 'text-center table-condensed' })
        }
      }
      else if (this.entitiesType === 'decentralised') {
        field =  [
          { key: 'RoutingName', label: this.$t('common.routing.routing_name_' + this.entitiesType), class: 'text-center table-condensed' },
          { key: 'ReceiverId', label: this.$t('common.routing.receiver_id_' + this.entitiesType), class: 'text-center table-condensed' },
          { key: 'NameConfigOutput', label: this.$t('common.routing.connector_name_responder'), class: 'text-center table-condensed' },
          { key: 'Active', label: this.$t('common.routing.active'), class: 'text-center table-condensed' },
        ]
        if (this.flagCACP) {
          field.splice(0, 0, { key: 'RoutingName', label: this.$t('common.routing.flagCACP.entity_routing_name'), class: 'text-center table-condensed' })
          field.splice(1, 0, { key: 'ReceiverId', label: this.$t('common.routing.flagCACP.entity_bic'), class: 'text-center table-condensed' })
          field.splice(2, 0, { key: 'BillableBic', label: this.$t('common.routing.flagCACP.billable_bic'), class: 'text-center table-condensed' })
          field.push({ key: 'Active', label: this.$t('common.routing.flagCACP.activity'), class: 'text-center table-condensed' })
        }
      }
      else{
        field =  [
          { key: 'RoutingType', label: this.$t('common.routing.routing_type'), class: 'text-center table-condensed' },
          { key: 'RoutingName', label: this.$t('common.routing.routing_name_' + this.entitiesType), class: 'text-center table-condensed' },
          { key: 'ReceiverId', label: this.$t('common.routing.receiver_id_' + this.entitiesType), class: 'text-center table-condensed' },
          // { key: 'RoutingDescription', label: this.$t('common.desc'), class: 'text-center table-condensed' },
          { key: 'ConfigType', label: this.$t('common.routing.config_type'), class: 'text-center table-condensed' },
          { key: 'ConfigIn', label: this.$t('common.routing.connector_name_receiver'), class: 'text-center table-condensed' },
          { key: 'ConfigOut', label: this.$t('common.routing.connector_name_responder'), class: 'text-center table-condensed' },
          { key: 'Active', label: this.$t('common.routing.active'), class: 'text-center table-condensed' },
          // { key: 'ConfigTypeSender', label: this.$t('common.routing.config_type_sender'), class: 'text-center table-condensed' },
          // { key: 'ConfigNameSender', label: this.$t('common.routing.config_name_sender'), class: 'text-center table-condensed' },
        ]
      }
      return field
    },
    statusDisplay () {
      let realCorporateIdentifierType = Object.values(this.corporateIdentifierType).filter(status => status.state === 1)
      if (realCorporateIdentifierType.length === 0) {
        if (this.flagCACP && (this.entitiesType === 'responder' || this.entitiesType === 'decentralised')) {
          return {
            label: this.$t('common.routing.flagCACP.eligible_id_selected_none'),
            nb: 0
          }
        } else {
          return {
            label: this.$t('filter.selected_corporate_identifier_type_none'),
            nb: 0
          }
        }
      } else if (realCorporateIdentifierType.length === 1) {
        return {
          label: realCorporateIdentifierType[0].label,
          nb: 1
        }
      } else {
        if (this.flagCACP && (this.entitiesType === 'responder' || this.entitiesType === 'decentralised')) {
          return {
            label: this.$t('common.routing.flagCACP.eligible_id_selected_many', {nbStatus: realCorporateIdentifierType.length}),
            nb: 0
          }
        } else {
          return {
            label: this.$t('filter.selected_corporate_identifier_type_many', {nbStatus: realCorporateIdentifierType.length}),
          }
        }
      }
    }
  },
  data () {
    return {
      activateSpinner: false,
      filterValues: {
        receiverId: '',
        billableBic: '',
        bicOnUs: false,
        status: '',
        routingType: '',
        configurationType: '',
        date: '',
        RVM: ''
      },
      timezone: '+00:00',
      corporateIdentifierType: {
        BANK: {
          label: this.$t('tracking.select.identifiers.BANK.label'),
          value: 1,
          state: 0
        },
        CBID: {
          label: this.$t('tracking.select.identifiers.CBID.label'),
          value: 2,
          state: 0
        },
        CHID: {
          label: this.$t('tracking.select.identifiers.CHID.label'),
          value: 3,
          state: 0
        },
        CINC: {
          label: this.$t('tracking.select.identifiers.CINC.label'),
          value: 4,
          state: 0
        },
        COID: {
          label: this.$t('tracking.select.identifiers.COID.label'),
          value: 5,
          state: 0
        },
        CUST: {
          label: this.$t('tracking.select.identifiers.CUST.label'),
          value: 6,
          state: 0
        },
        DUNS: {
          label: this.$t('tracking.select.identifiers.DUNS.label'),
          value: 7,
          state: 0
        },
        EMPL: {
          label: this.$t('tracking.select.identifiers.EMPL.label'),
          value: 8,
          state: 0
        },
        GS1G: {
          label: this.$t('tracking.select.identifiers.GS1G.label'),
          value: 9,
          state: 0
        },
        SREN: {
          label: this.$t('tracking.select.identifiers.SREN.label'),
          value: 10,
          state: 0
        },
        SRET: {
          label: this.$t('tracking.select.identifiers.SRET.label'),
          value: 11,
          state: 0
        },
        TXID: {
          label: this.$t('tracking.select.identifiers.TXID.label'),
          value: 12,
          state: 0
        },
        BDID: {
          label: this.$t('tracking.select.identifiers.BDID.label'),
          value: 13,
          state: 0
        },
        BOID: {
          label: this.$t('tracking.select.identifiers.BOID.label'),
          value: 14,
          state: 0
        },
        LEIC: {
          label: this.$t('tracking.select.identifiers.LEIC.label'),
          value: 15,
          state: 0
        },
        EUID: {
          label: this.$t('tracking.select.identifiers.EUID.label'),
          value: 16,
          state: 0
        }
      },
      displayFilter: false,
      flagCACP: conf.visual === 'CACP',
      messageRoutingIn: [],
      messageRoutingOut: [],
      pageCounter: 0,
      paginationObject: {},
      role: 0,
      type: 0,
      entityType: 0,
      demo: true,
      tabNameSelected: 'Corporate'
    }
  },
  created () {
    this.timezone = moment.tz.guess()
    if (this.tabName == 3) {
      this.tabNameSelected = 'Corporate'
    }
    if (this.tabName == 4) {
      this.tabNameSelected = 'SI'
    }
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0

    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.refreshItems(index)
      that.pageCounter = 0
    })
    if (this.entitiesType === 'requester') {
      this.type = 0
      this.role = 1
      this.entityType = 0
    } else if (this.entitiesType === 'responder') {
      this.type = 1
      this.role = 0
      this.entityType = 2
    }
    this.pageCounter = 0
    this.onRefresh()

  },
  mounted () {
  },
  beforeDestroy () {
  },
  watch: {
    // role () {
    //   this.getMessageRouting()
    // },
    // type () {
    //   this.getMessageRouting()
    // }
  },
  methods: {
    getAddButtonText () {
      if (this.entitiesType == 'rvm') {
        return this.$t('common.routing.add_rvm')
      } else if (this.entitiesType == 'requester') {
        return this.$t('common.routing.add_corporate')
      } else if (this.entitiesType == 'responder') {
        return this.$t('common.routing.add_si')
      } else if (this.entitiesType == 'decentralised') {
        return this.$t('common.routing.add_si_decentralised')
      }
      return ''
    },
    canGetEntityGroup () {
      return this.$engine.firstOn().rights.rightIs('entityGroup_consult', true)
    },
    getEntityGroup () {
      loadPage(this, {url: '/entityGroup/' })
    },
    addMessageRouting () {
      loadPage(this, {url: '/routing/messageDetails/create/' + this.role + '/' + this.type + '/' + this.entitiesType + '/' + this.tabNameSelected})
    },
    addImportReferentiel () {
      loadPage(this, {url: '/routing/messageDetails/import/'+ this.entitiesType})
    },
    canViewConnector() {
      return this.$engine.firstOn().rights.rightIs('messageRoutingConfig_connector', true)
    },
    clearFilterFields() {
      this.filterValues.receiverId = ''
      this.filterValues.billableBic = ''
      this.filterValues.bicOnUs = false
      this.filterValues.status = ''
      this.filterValues.routingType = ''
      this.filterValues.configurationType = ''
      this.filterValues.date = ''
      this.filterValues.RVM = ''
    },
    onFilterChanged({ prop, value }) {
      this.filterValues[prop] = value
    },
    toggleFilter() {
      this.displayFilter = !this.displayFilter
    },
    getEntityBicLabel() {
      if (this.flagCACP) {
        return this.$t('common.routing.flagCACP.entity_bic')
      }
      return this.$t('common.routing.receiver_id_' + this.entitiesType)
    },
    extractCSV () {
        this.$f7.showPreloader(this.$i18n.t('common.loading_page_label'))
        let params = {
          Role: this.role,
          Type: this.type,
          entityType: this.entityType,
          ReceiverId: this.filterValues.receiverId,
          BillableBic: this.filterValues.billableBic,
          BicOnUs: this.filterValues.bicOnUs,
          Status: this.filterValues.status,
          RoutingType: this.filterValues.routingType,
          ConfigurationType: this.filterValues.configurationType,
          Date: this.filterValues.date != '' ? moment(this.filterValues.date, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
          RVM: this.filterValues.RVM,
          Extract: 1
        }
        if (this.entitiesType === 'rvm'){
          params.rvm = '1'
        }
        if (this.entitiesType === 'decentralised'){
          params.Role = '0'
          params.entityType = '1'
          params.messageType = '2'
          params.decentralised = '1'
        }
        let that = this
        this.$engine.firstOn().routing.message.fetch(
            params
        ).then(resp => {
          this.$f7.hidePreloader()
          const binaryString = window.atob(resp.data.data)
          const len = binaryString.length
          const bytes = new Uint8Array(len)
          for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i)
          }

          const csvData = new TextDecoder('utf-8').decode(bytes)



          const rows = csvData.split('\n').map(row => row.split(';'))
          const headers = rows[0].map(header => header.replace(/\"/g, '').trim())
          const dataIndex = headers.indexOf('RequestStatus')

          const modifiedRows = rows.map((row, index) => {
            if (index === 0) return row
            if (row[dataIndex] && dataIndex !== -1) {
              row[dataIndex] = that.translateTechStatusCode(row[dataIndex])
            } else{
              row[dataIndex] = that.$t('common.monitoring.success')
            }
            return row
          })

          const modifiedCsv = "\ufeff" + modifiedRows.map(row => row.join(';')).join('\n')

          const linkSource = 'data:text/csv;charset=utf-8,' + encodeURIComponent(modifiedCsv)

          let downloadLink = document.createElement('a')
          let today = moment.tz(moment(), this.timezone)
          let fileName = 'routing_configuration_'
          let fileNameComplet = fileName + today.unix() + '.csv'
          if (
              this.$f7.device.os === 'android' ||
              this.$f7.device.os === 'ios'
          ) {
            downloadFileWithDefinedHeaders(this, fileNameComplet, linkSource)
          } else {
            downloadLink.href = linkSource
            downloadLink.download = fileNameComplet
            downloadLink.click()
          }
          this.$f7.alert('', this.$i18n.t('common.exprt_succ'))

        })
            .catch(error => {
              this.$f7.hidePreloader()
              errorMessageAlert(error, that)
            })
    },
    onRefresh () {
      this.activateSpinner = true
      this.refreshItems()
    },
    getConfiguration (entitiesType) {
      if (this.entitiesType === 'rvm' && entitiesType === 'requester'){
        loadPage(this, {url: '/routing/configlist/1/' + this.type + '/' + this.entitiesType})
      }
      else if (this.entitiesType === 'rvm' && entitiesType === 'responder'){
        loadPage(this, {url: '/routing/configlist/0/' + this.type + '/' + this.entitiesType})
      }else{
        loadPage(this, {url: '/routing/configlist/' + this.role + '/' + this.type + '/' + entitiesType})
      }
    },
    getConfigurationS3 (messageType, entityType, type = 'S3') {
      if(type == "S3"){
        loadPage(this, {url: '/routing/configS3list/' + messageType + '/' + entityType})
      }
      else{
        loadPage(this, {url: '/routing/configS3/webservice/details'})
      }
    },
    refreshItems (index = 1) {
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0
      let params = {
        Role: this.role,
        Type: this.type,
        entityType: this.entityType,
        ReceiverId: this.filterValues.receiverId,
        BillableBic: this.filterValues.billableBic,
        BicOnUs: this.filterValues.bicOnUs,
        Status: this.filterValues.status,
        RoutingType: this.filterValues.routingType,
        ConfigurationType: this.filterValues.configurationType,
        Date: this.filterValues.date != '' ? moment(this.filterValues.date, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
        RVM: this.filterValues.RVM,
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex
      }
      if (this.entitiesType === 'rvm'){
        params.rvm = '1'
      }
      if (this.entitiesType === 'decentralised'){
        params.Role = '0'
        params.entityType = '1'
        params.messageType = '2'
        params.decentralised = '1'
      }
      let that = this
      this.$engine.firstOn().routing.message.fetch(
        params
      ).then(resp => {
        let messageRouting = {}

        that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        that.paginationObject.nbResults = resp.data.MessageRouting.length
        messageRouting = resp.data.MessageRouting

        this.messageRoutingIn = messageRouting
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    getMessageRouting (IdMessageRouting) {
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0
      let params = {
        Role: this.role,
        Type: this.type,
        entityType: this.entityType,
        ReceiverId: this.filterValues.receiverId,
        BillableBic: this.filterValues.billableBic,
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex,
        IdMessageRouting: IdMessageRouting
      }
      if (this.entitiesType === 'rvm'){
        params.rvm = '1'
      }
      if (this.entitiesType === 'decentralised'){
        params.Role = '0'
        params.entityType = '1'
        params.messageType = '2'
        params.decentralised = '1'
      }
      let that = this
      this.$engine.firstOn().routing.message.fetch(
        params
      ).then(resp => {
        let messageRouting = {}

        that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        that.paginationObject.nbResults = resp.data.MessageRouting.length
        messageRouting = resp.data.MessageRouting

        // Group by ReceiverId, RoutingName, and RoutingDescription
        const grouped = messageRouting.reduce((acc, item) => {
          const key = `${item.ReceiverId}-${item.RoutingName}-${item.RoutingDescription}`
          if (!acc[key]) {
            acc[key] = {
              ReceiverId: item.ReceiverId,
              RoutingName: item.RoutingName,
              MemberId: item.MemberId,
              AcceptableErrorThreshold: item.AcceptableErrorThreshold,
              MessageType: item.MessageType,
              RoutingType: item.RoutingType,
              RoutingDescription: item.RoutingDescription,
              CertIdentifier: item.CertIdentifier,
              HeaderValue: item.HeaderValue,
              CorporateIdentifierType: item.corporateIdentifierType,
              IdAccount: item.IdAccount,
              Role: item.Role,
              Active: item.Active,
              Type: item.Type,
              BillableBic: item.BillableBic,
              BICParticipant: item.BICParticipant,
              EntityCountry: item.EntityCountry,
              EntityTypeCacp: item.EntityTypeCacp,
              CreationDate: item.CreationDate,
              ModificationDate: item.ModificationDate,
              ServiceStartDate: item.ServiceStartDate,
              DeactivationDate: item.DeactivationDate,
              ActivityProof: item.ActivityProof,
              ActivityProofStet: item.ActivityProofStet,
              ActivityProofEba: item.ActivityProofEba,
              SubscribedServices: item.subscribedServices,
              UnitDdv: item.UnitDdv,
              BulkDdv: item.BulkDdv,
              StatusDo: item.StatusDo,
              EntityGroupCacp: item.EntityGroupCacp,
              Configs: [
              ]
            }

            if(item.IdConfigInput != ''){
              acc[key].Configs.push({ConfigName: item.NameConfigInput,ConfigType: item.ConfigType, IdConfig: item.IdConfigInput, IdMessageRouting: item.IdMessageRouting})
            } else {
              acc[key].Configs.push({ConfigName: '',ConfigType: 'NULL', IdConfig: '', IdMessageRouting: ''})
            }
            if(item.IdConfigOutput != ''){
              acc[key].Configs.push({ConfigName: item.NameConfigOutput,ConfigType: item.ConfigType, IdConfig: item.IdConfigOutput, IdMessageRouting: item.IdMessageRouting})
            } else {
              acc[key].Configs.push({ConfigName: '',ConfigType: item.ConfigType, IdConfig: '', IdMessageRouting: ''})
            }

          }
          else {
            if(item.IdConfigInput != ''){
              acc[key].Configs[0] = {ConfigName: item.NameConfigInput,ConfigType: item.ConfigType, IdConfig: item.IdConfigInput, IdMessageRouting: item.IdMessageRouting}
            }
            if(item.IdConfigOutput != ''){
              acc[key].Configs[1] = {ConfigName: item.NameConfigOutput,ConfigType: item.ConfigType, IdConfig: item.IdConfigOutput, IdMessageRouting: item.IdMessageRouting}
            }
          }
          return acc
        }, {})

        let results = Object.values(grouped)

        let firstIndex = that.paginationObject.firstIndex
        let maxResults = that.paginationObject.maxResults

        if (firstIndex > results.length) {
          firstIndex = 0
        } else if (firstIndex > 0) {
          firstIndex -= 1
        }

        results = results.slice(firstIndex, firstIndex + maxResults)

        let messageRoutingItem = results[0]
        this.$engine.firstOn().routing.message.clickedMessage = messageRoutingItem
        loadPage(this, {url: '/routing/messageDetails/details/' + messageRoutingItem.Role + '/' + messageRoutingItem.Type + '/' + this.entitiesType +'/' + this.tabName})

      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    seeDetails (items) {
      let MessageRoutingIndex = items[0].IdMessageRouting

      this.getMessageRouting(MessageRoutingIndex)
      }
  }
}
</script>

<style scoped>

@media (max-width: 1400px) {
  .responsive-button {
    min-height: 85px;
  }
}
</style>
